export interface ColourStop {
  stop: number
  colour: string
}

export const fadedGradientStops: ColourStop[] = [
  { stop: 0, colour: '#030303' },
  { stop: 0.05, colour: '#131818' },
  { stop: 0.29, colour: '#2A5157' },
  { stop: 0.52, colour: '#808080' },
  { stop: 0.75, colour: '#CFAA86' },
  { stop: 0.88, colour: '#DFD0B8' },
  { stop: 1, colour: '#FDFDFE' }
]

export const vintageGradientStops: ColourStop[] = [
  { stop: 0, colour: '#030303' },
  { stop: 0.03, colour: '#130E18' },
  { stop: 0.25, colour: '#663844' },
  { stop: 0.5, colour: '#828282' },
  { stop: 0.75, colour: '#D9BD81' },
  { stop: 1, colour: '#F3EDC9' }
]

export const contrastGradientStops: ColourStop[] = [
  { stop: 0, colour: '#000000' },
  { stop: 0.75, colour: '#FEFEFE' },
  { stop: 1, colour: '#010101' }
]

export const sepiaGradientStops: ColourStop[] = [
  { stop: 0, colour: '#030303' },
  { stop: 0.02, colour: '#161512' },
  { stop: 0.25, colour: '#5A3B02' },
  { stop: 0.5, colour: '#997B3F' },
  { stop: 0.75, colour: '#D9BD81' },
  { stop: 0.98, colour: '#F3EDC9' },
  { stop: 1, colour: '#FFFFFF' }
]

export const coolGradientStops: ColourStop[] = [
  { stop: 0, colour: '#030303' },
  { stop: 0.03, colour: '#0C0B0B' },
  { stop: 0.25, colour: '#47443F' },
  { stop: 0.5, colour: '#827E76' },
  { stop: 0.75, colour: '#94CEF1' },
  { stop: 0.98, colour: '#F2FFFF' },
  { stop: 1, colour: '#FCFCFC' }
]
